import { error } from 'services/graphql/fragments/Fragments';
import { AnalyticsFragment } from 'services/graphql/fragments/VxlFragments';
import { gql } from 'urql';

const FetchDebtSaleAccountDetails = gql`
  query debtSaleAccountDetails($accountId: ID!) {
    debtSaleAccountDetails(accountId: $accountId) {
      ... on DebtSaleAccountDetailsSuccess {
        __typename
        id
        pageTitle: title
        subtitle
        footnote
        buyer {
          id
          name
        }
        sections {
          id
          title
          body
        }
        paymentPortalButton {
          label
          contactMethod {
            id
            type
            label
            action {
              id
              deeplink
              analyticsEvent {
                ...analytics
              }
            }
          }
        }
      }
      ... on DebtSaleAccountDetailsError {
        __typename
        ...error
      }
    }
  }
  ${AnalyticsFragment}
  ${error}
`;

export default FetchDebtSaleAccountDetails;
